import { UPDATE_CHARGE_AMOUNT, UPDATE_DCC_DATA, SET_SESSION_EXPIRED } from "../helpers/actions";
import { withProperties, isPlainObject, getValueAtPath } from "../../utils";

export default function state() {
  const NAME = 'amount';
  const $state = Object.create(null);
  const { data } = this;

  const initialAmount = getValueAtPath(data, 'amount') || null;

  function Reducer(state = initialAmount, action) {
    const payload = isPlainObject(action.payload) ? action.payload : {};

    switch (action.type) {
      case UPDATE_CHARGE_AMOUNT: {
        const { amount } = payload;
        return +amount || state;
      }

      // On session expiry, drop any fee-adjusted amount and reset to the
      // original so a stale fee can't linger into a refreshed session.
      case SET_SESSION_EXPIRED: {
        return initialAmount;
      }

      default: return state;
    }
  }

  function updateChargeAmount(amount) {
    return (dispatch) => {
      dispatch({ type: UPDATE_CHARGE_AMOUNT, payload: {
        amount: getValueAtPath(amount, "charge_amount") || amount
      }});
      dispatch({ type: UPDATE_DCC_DATA, payload: {
        dcc: getValueAtPath(amount, "dcc")
      }});
    }
  }

  // Augment $state with properties
  withProperties($state, {
    NAME,
    Reducer,
    actions: withProperties(Object.create(null), { updateChargeAmount })
  });

  return (state = $state);
}